var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconeImportacao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2433 11.5774C17.4736 11.7768 17.4736 12.1339 17.2433 12.3333L14.8253 14.4274C14.5015 14.7078 13.998 14.4778 13.998 14.0494V13.3268H10.0944C9.81822 13.3268 9.59436 13.103 9.59436 12.8268V11.0835C9.59436 10.8074 9.81822 10.5835 10.0944 10.5835H13.998V9.86132C13.998 9.43295 14.5015 9.20292 14.8253 9.48336L17.2433 11.5774Z",
    fill: "white",
    fillOpacity: 0.55
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.56215 0H12.7418C13.2202 0 13.6081 0.387853 13.6081 0.866295V8.3381C13.6081 8.49758 13.4788 8.62686 13.3193 8.62686C13.1598 8.62686 13.0305 8.49758 13.0305 8.3381V0.866295C13.0305 0.706815 12.9012 0.57753 12.7418 0.57753H3.97052V3.10423C3.97052 3.58267 3.58267 3.97052 3.10423 3.97052H0.57753V15.1602C0.57753 15.3197 0.706815 15.4489 0.866296 15.4489H10.937C11.0965 15.4489 11.2257 15.5782 11.2257 15.7377C11.2257 15.8972 11.0965 16.0265 10.937 16.0265H0.866296C0.387854 16.0265 0 15.6386 0 15.1602V3.56215L3.56215 0ZM0.985906 3.39299H3.10423C3.26371 3.39299 3.39299 3.26371 3.39299 3.10423V0.985906L0.985906 3.39299Z",
    fill: "white",
    fillOpacity: 0.55
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87695 5.4145C1.87695 5.25502 2.00624 5.12573 2.16572 5.12573H12.2003C12.3598 5.12573 12.4891 5.25502 12.4891 5.4145C12.4891 5.57398 12.3598 5.70326 12.2003 5.70326H2.16572C2.00624 5.70326 1.87695 5.57398 1.87695 5.4145Z",
    fill: "currentColor",
    fillOpacity: 0.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87695 8.01337C1.87695 7.85389 2.00624 7.72461 2.16572 7.72461H10.576C10.7355 7.72461 10.8648 7.85389 10.8648 8.01337C10.8648 8.17286 10.7355 8.30214 10.576 8.30214H2.16572C2.00624 8.30214 1.87695 8.17286 1.87695 8.01337Z",
    fill: "currentColor",
    fillOpacity: 0.55
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87695 10.612C1.87695 10.4525 2.00624 10.3232 2.16572 10.3232H7.39959C7.55907 10.3232 7.68835 10.4525 7.68835 10.612C7.68835 10.7715 7.55907 10.9008 7.39959 10.9008H2.16572C2.00624 10.9008 1.87695 10.7715 1.87695 10.612Z",
    fill: "currentColor",
    fillOpacity: 0.55
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.87695 13.2109C1.87695 13.0514 2.00624 12.9221 2.16572 12.9221H7.39959C7.55907 12.9221 7.68835 13.0514 7.68835 13.2109C7.68835 13.3704 7.55907 13.4996 7.39959 13.4996H2.16572C2.00624 13.4996 1.87695 13.3704 1.87695 13.2109Z",
    fill: "currentColor",
    fillOpacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeImportacao);
export default __webpack_public_path__ + "static/media/iconeImportacao.483f968f2517ecbc51134b7e01c83885.svg";
export { ForwardRef as ReactComponent };